import posthog from 'posthog-js';
import { useAuth } from 'react-oidc-context';
import { QueryCache } from 'react-query';

import { FLAGS } from '../utils/feature-flag';
import { clearSessionStorage } from './session';

export const useLogout = () => {
  const auth = useAuth();
  const queryCache = new QueryCache();

  const logout = async () => {
    clearSessionStorage();
    queryCache.clear();
    const merchantOidcEnabled =
      process.env.REACT_APP_IS_ADMIN === 'true' ||
      posthog.isFeatureEnabled(FLAGS.MERCHANT_OIDC) === true;

    if (merchantOidcEnabled && auth.isAuthenticated) {
      const signoutParams = {
        id_token_hint: auth.user?.id_token,
        post_logout_redirect_uri:
          process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || window.location.origin + '/login'
      };

      try {
        await auth.signoutRedirect(signoutParams);
      } catch (error) {
        // Fallback if signoutRedirect fails
        console.error('Logout failed', error);
        window.location.replace('/login');
      }
    } else {
      window.location.replace('/login');
    }
  };

  return logout;
};
